module.exports = __webpack_public_path__ + "img/2fcb0ce.png";